<template>
  <div class="bd">
    <!-- src="https://www.thingjs.com/s/2e379ee6e7cf06dd9eaa19ad" -->
    <div class="main" :style="'height:' + screenHeight">
      <div class="left">
        <div class="heade">无污染输液瓶（袋）处理车间</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="">
              <div class="left-content slip_out_animation">
                <div class="type-title">
                  <div>累计处理</div>
                  <div>
                    <el-date-picker
                      v-model="valueLeftTop"
                      type="daterange"
                      range-separator="~"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :clearable="false"
                    >
                    </el-date-picker>
                  </div>
                </div>
                <div style="margin-top: 30px; padding-left: 20px">
                  当前累计处理量：23吨
                </div>

                <div class="left-echarts-1" id="left-echarts-1"></div>
              </div>
              <div class="left-content slip_out_animation">
                <div class="type-title">
                  <div>当前处理</div>
                  <div>
                    <el-date-picker
                      v-model="valueLeftTop"
                      type="daterange"
                      range-separator="~"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :clearable="false"
                    >
                    </el-date-picker>
                  </div>
                </div>
                <div class="current">
                  <el-row>
                    <el-col :span="12"
                      ><div class="current-left">
                        <img
                          class="img"
                          src="@/assets/images/right-icon1.png"
                          alt=""
                          srcset=""
                        />
                        <span>回收量</span>
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="current-right">
                        <span>3451 </span> <span>吨</span>
                      </div></el-col
                    >
                  </el-row>
                </div>
                <div class="current">
                  <el-row>
                    <el-col :span="12"
                      ><div class="current-left">
                        <img
                          class="img"
                          src="@/assets/images/right-icon2.png"
                          alt=""
                          srcset=""
                        />
                        <span>处理量</span>
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="current-right">
                        <span>5111 </span> <span>吨</span>
                      </div></el-col
                    >
                  </el-row>
                </div>
                <div class="current">
                  <el-row>
                    <el-col :span="12"
                      ><div class="current-left">
                        <img
                          class="img"
                          src="@/assets/images/right-icon1.png"
                          alt=""
                          srcset=""
                        />
                        <span>产出</span>
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="current-right">
                        <span>3435 </span> <span>吨</span>
                      </div></el-col
                    >
                  </el-row>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="">
              <div class="left-content slip_out_animation" style="padding-bottom:0">
                <div class="type-title">
                  <div>年度处理量</div>
                  <div style="width: 100px">
                    <el-select v-model="valueLeftBottom" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div style="margin-top: 10px; padding-left: 20px">单位吨</div>

                <div class="left-echarts-2" id="left-echarts-2"></div>
              </div>

              <div class="left-content slip_out_animation">
                <div class="type-title">
                  <div>销售信息</div>
                </div>
                <div id="left-echarts-3" class="left-echarts-3"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="right">
        <div class="heade">医废处理车间</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="">
              <div class="right-content slip_in_animation">
                <div class="type-title">
                  <div>业务统计</div>
                </div>
                <div class="supplier">
                  <div
                    class="supplier-supplieritme"
                    v-for="item in supplierData"
                    :key="item.name"
                  >
                    <div class="supplier-name">{{ item.name }}</div>
                    <div class="supplier-count">
                      {{ item.count + "    " + item.unit }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-content slip_in_animation">
                <div class="type-title">
                  <div>医疗废物收运情况</div>
                  <div style="width: 100px">
                    <el-select v-model="valueLeftBottom" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div style="margin-top: 10px; padding-left: 20px">单位吨</div>
                <div class="right-echarts-1" id="right-echarts-1"></div>

                <div></div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="">
              <div
                class="right-content slip_in_animation"
                style="padding-bottom: 0"
              >
                <div class="type-title">
                  <div>趋势分析</div>
                  <div style="width: 100px">
                    <el-select v-model="valueLeftBottom" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="right-echarts-2" id="right-echarts-2"></div>
              </div>

              <div class="right-content slip_in_animation">
                <div class="type-title">
                  <div>医废收运量及处置量分析</div>
                  <div style="width: 100px">
                    <el-select v-model="valueLeftBottom" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div style="margin-top: 20px; padding-left: 20px"></div>

                <div class="right-echarts-3" id="right-echarts-3"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
  
  <script>
// 引入封装好的接口
import { getData, getData2 } from "@/api/home.js";

// import "swiper/css/swiper.css"; //引入swiper样式
import Swiper from "swiper"; //引入swiper
import "swiper/dist/css/swiper.css";
import * as echarts from "echarts";

export default {
  name: "indexModelTwo",
  props: ["screenHeight"],
  data() {
    return {
      supplierData: [
        { name: "签约医院", count: 413, unit: "家" },
        { name: "收运司机", count: 1, unit: "位" },
        { name: "收运车辆", count: 413, unit: "辆" },
        { name: "医废收集量", count: 27.19, unit: "吨" },
        { name: "医废处置量", count: 25.43, unit: "吨" },
        { name: "贮存量", count: 1.76, unit: "吨" },
      ],
      selectIndex: 1,
      nowTime: "",
      valueLeftTop: ["2023-01-03", "2023-01-20"],
      valueRightTop: ["2023-01-03", "2023-01-20"],
      valueLeftBottom: "7",
      options: [
        {
          value: "1",
          label: "2017",
        },
        {
          value: "2",
          label: "2018",
        },
        {
          value: "3",
          label: "2019",
        },
        {
          value: "4",
          label: "2020",
        },
        {
          value: "5",
          label: "2021",
        },
        {
          value: "6",
          label: "2022",
        },
        {
          value: "7",
          label: "2023",
        },
      ],
      valueRightBottom: "7",
      optionsRight: [
        {
          value: "1",
          label: "2017",
        },
        {
          value: "2",
          label: "2018",
        },
        {
          value: "3",
          label: "2019",
        },
        {
          value: "4",
          label: "2020",
        },
        {
          value: "5",
          label: "2021",
        },
        {
          value: "6",
          label: "2022",
        },
        {
          value: "7",
          label: "2023",
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.createdCarEchartsLeftTop();
        this.createdCarEchartsLeftBottom();
        this.createdCarEchartsRightBottom();
        this.createdCarEchartsRightTop();
        this.right1();
        this.right3();
      });
    }, 200);
  },
  methods: {
    async right3() {
      let handleValue = [20, 25, 25, 45]; //处理量
      let recoveryValue = [20, 25, 25, 45]; //回收量
      let monthValue = ["一月", "二月", "三月", "四月"]; //月份

      var leftEchartsTOP = document.getElementById("right-echarts-3");
      var myChart = echarts.init(leftEchartsTOP);
      var option;

      // let res = await getData({ year: 2023 });
      // handleValue = res.handleValue;
      // recoveryValue = res.recoveryValue;
      // monthValue = res.monthValue;
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
            },
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        calculable: true,

        legend: {
          // show: false,
          data: ["Growth", "处理量", "回收量"],
          itemGap: 5,
          bottom: "bottom",
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },
        grid: {
          top: "6%",
          left: "3%",
          right: "4%",
          bottom: "15%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: monthValue,
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                color: "#094060",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                color: "#094060",
              },
            },
          },
        ],
        series: [
          {
            name: "处理量",
            type: "bar",
            barGap: "0%",
            data: handleValue,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  formatter: function (val) {
                    if (val.value == 0) {
                      return "";
                    }
                  },
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 12,
                  },
                },
              },
            },
          },
          {
            name: "回收量",
            type: "bar",
            data: recoveryValue,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  formatter: function (val) {
                    if (val.value == 0) {
                      return "";
                    }
                  },
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 12,
                  },
                },
              },
            },
          },
        ],
      };
      option && myChart.setOption(option);

      // // 调用时使用
      // getData({ year: 2023 })
      //   .then((res) => {
      //     // console.log("res", res);
      //     handleValue = res.handleValue;
      //     recoveryValue = res.recoveryValue;
      //     option.series[0].data = handleValue;
      //     option.series[1].data = recoveryValue;
      //   })
      //   .catch((error) => {
      //     // console.log(error);
      //   });
    },
    right1() {
      var chartDom = document.getElementById("right-echarts-1");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: false,
          bottom: "bottom",
        },
        grid: {
          left: "3%",
          right: "4%",
          top: "10%",
          bottom: "0px",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          axisLabel: {
            color: "#fff",
          },
          axisLine: {
            lineStyle: {
              // color: "#fff",
              color: "#094060",
            },
          },
        },
        yAxis: {
          type: "category",
          axisLabel: {
            color: "#fff",
          },
          data: ["百花湖镇", "朱仓镇", "南明区", "高新区", "白云区", "白岩区"],
          axisLine: {
            lineStyle: {
              // color: "#fff",
              color: "#094060",
            },
          },
        },
        series: [
          {
            name: "数据",
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: [320, 302, 301, 334, 390, 330, 320],
            itemStyle: {
              color: function (params) {
                // 通过返回值的下标一一对应将颜色赋给柱子上，return出去什么颜色就是什么颜色，这里可以写判断
                // console.log(params)
                return "#4587E7";
                // return colors[params.dataIndex];
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },

    // 饼图
    createdCarEchartsLeftTop() {
      var leftEchartsTOP = document.getElementById("left-echarts-1");
      var myChart = echarts.init(leftEchartsTOP);
      var option;

      option = {
        title: {
          subtext: "单位：吨",
          left: "right",
          subtextStyle: {
            color: "#FFF",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return (
              params.name +
              ":  " +
              params.data.value +
              "（" +
              params.percent +
              "%）"
            );
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        legend: {
          // show: false,
          bottom: "bottom",
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },
        series: [
          {
            name: "数量",
            type: "pie",
            radius: "50%",
            data: [
              { value: 1048, name: "输液瓶" },
              { value: 735, name: "输液袋" },
              { value: 580, name: "塑料药瓶" },
            ],
            label: {
              color: "#FFF",
              formatter(param) {
                return param.data.value;
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    // 折线图
    async createdCarEchartsLeftBottom() {
      var leftEchartsTOP = document.getElementById("left-echarts-2");

      var myChart = echarts.init(leftEchartsTOP);
      var option;
      let series = [];

      // let res = await getData2({ year: 2023 });
      // res.data.forEach((item) => {
      //   let obj = {
      //     name: item.name,
      //     type: "line",
      //     stack: "Total",
      //     smooth: true,
      //     data: item.value,
      //   };
      //   series = [...series, obj];
      // });

      option = {
        tooltip: {
          trigger: "axis",
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        legend: {
          // show: false,
          bottom: "bottom",
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },
        grid: {
          top: "5%",
          left: "3%",
          right: "4%",
          bottom: "15%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月",
          ],
          axisLabel: {
            interval: 1,
            color: "#fff",
          },
          axisLine: {
            lineStyle: {
              // color: "#fff",
              color: "#094060",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#ffffff",
          },
          axisLine: {
            lineStyle: {
              // color: "#fff",
              color: "#094060",
            },
          },
        },
        series: [
          {
            name: "输液瓶",
            type: "line",
            stack: "Total",
            smooth: true,
            data: [4, 13, 230, 13, 9, 23, 21, 12, 12, 300, 13, 3, 23, 21],
          },
          {
            name: "输液袋",
            type: "line",
            stack: "Total",
            smooth: true,
            data: [22, 82, 300, 24, 90, 30, 10, 30, 11, 24, 29, 33, 30],
          },
          {
            name: "塑料瓶",
            type: "line",
            stack: "Total",
            smooth: true,
            data: [15, 23, 20, 14, 19, 30, 10, 23, 3, 14, 19, 30, 40],
          },
        ],
      };

      option && myChart.setOption(option);
    },
    // 柱形图
    createdCarEchartsRightBottom() {
      var leftEchartsTOP = document.getElementById("left-echarts-3");
      var myChart = echarts.init(leftEchartsTOP);
      var option;

      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
            },
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        calculable: true,

        legend: {
          // show: false,
          data: ["Growth", "销售重量（吨）", "销售金额（元）"],
          itemGap: 5,
          bottom: "bottom",
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },
        grid: {
          top: "6%",
          left: "3%",
          right: "4%",
          bottom: "15%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [2017, 2018, 2019, 2020, 2021],
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                color: "#094060",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                color: "#094060",
              },
            },
          },
        ],
        series: [
          {
            name: "销售重量（吨）",
            type: "bar",
            barGap: "0%",
            data: [223, 659, 2855, 1152, 666],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  formatter: function (val) {
                    if (val.value == 0) {
                      return "";
                    }
                  },
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 12,
                  },
                },
              },
            },
          },
          {
            name: "销售金额（元）",
            type: "bar",
            data: [99, 56, 1233, 846, 999],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  formatter: function (val) {
                    if (val.value == 0) {
                      return "";
                    }
                  },
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 12,
                  },
                },
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    // 柱形图
    createdCarEchartsRightTop() {
      var leftEchartsTOP = document.getElementById("right-echarts-2");
      var myChart = echarts.init(leftEchartsTOP);
      var option;

      option = {
        tooltip: {
          trigger: "axis",
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        legend: {
          // show: false,
          bottom: "bottom",
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },
        grid: {
          top: "5%",
          left: "3%",
          right: "4%",
          bottom: "15%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月",
          ],
          axisLabel: {
            interval: 1,
            color: "#fff",
          },
          axisLine: {
            lineStyle: {
              // color: "#fff",
              color: "#094060",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#ffffff",
          },
          axisLine: {
            lineStyle: {
              // color: "#fff",
              color: "#094060",
            },
          },
        },
        series: [
          {
            name: "输液瓶",
            type: "line",
            stack: "Total",
            smooth: true,
            data: [4, 13, 230, 13, 9, 23, 21, 12, 12, 300, 13, 3, 23, 21],
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>
  <style scoped>
::-webkit-scrollbar {
  width: 0px;
}

.swiper-pagination-bullet-active {
  background-color: orangered;
}
.iframe {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
}
.head .title {
  flex: 1;
  color: #fff;
  text-align: center;
  font-size: 32px;
  padding-top: 15px;
}
.head .nowtime {
  color: #fff;
  position: absolute;
  right: 30px;
  top: 30px;
}
.main {
  display: flex;
  align-items: center;
  background: rgba(17, 47, 107, 0.6);
  width: 98.5vw;
  margin: 0 auto;
}
.main .left,
.main .right {
  /* width: 520px; */
  width: 50%;
  height: 75vh;
  overflow: hidden;
  color: #fff;
}
.main .left {
  /* float: left; */
  margin: 0 20px;
  padding: 20px 0 0 0;
  border-right: 1px dashed #eee;
}
.main .right {
  /* float: right; */
  padding: 20px 0 0 0;

  margin: 0 20px;
}

.main .left .heade,
.main .right .heade {
  font-size: 30px;
  font-weight: bold;
}
.main .left-container,
.main .right-container {
  display: flex;
}

.main .left .left-content {
  box-sizing: border-box;
  padding: 20px;
  color: #fff;
  /* height: 50%; */
}
::v-deep .main .left .left-content .type-title,
.main .right .right-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main .right .right-content {
  padding: 20px;
  color: #fff;
  height: 50%;
}

.main .right .right-content .right-content-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.main .right .right-content .right-bottom-content {
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
  height: 35vh;
}

.main .right .right-content .right-bottom-content .right-bottom-content-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  color: #fff;
  padding: 20px 0;
  border-bottom: 1px rgb(55, 51, 51) dotted;
}

.right-top-item {
  box-sizing: border-box;
}
.right-top-item-title {
  display: flex;
  align-items: center;
  font-size: 24px;
}
.right-top-item-title img {
  width: 30px;
  height: 30px;
  margin-right: 5px;
}
.right-top-item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  margin-top: 10px;
  font-size: 30px;
}
.middle {
  flex: 1;
  height: 75vh;
}
.middle-content {
  padding: 20px;
  padding-bottom: unset;
}
.middle-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
}
.middle-content .middle-top-box {
  display: flex;
  justify-content: space-between;
  color: #fff;
  /* padding-top: 30px;
  margin-bottom: 30px; */
}
.middle-content .middle-top-box .top-box-item {
  width: 50%;
}
.middle-content .middle-top-box .top-box-item .item-title {
  display: flex;
  align-items: center;
  font-size: 26px;
}
.middle-content .middle-top-box .top-box-item .item-title img {
  width: 60px;
  height: 60px;
}
.middle-content .middle-top-box .top-box-item .item-content {
  display: flex;
  flex-wrap: wrap;
}
.middle-content .middle-top-box .top-box-item .item-content .item {
  width: 50%;
  font-size: 34px;
  margin-top: 10px;
}
.middle-content .middle-top-box .top-box-item .item-content .itemspan {
  font-size: 22px;
}
.middle-center-box {
  padding: 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  height: 35vh;
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
}
.middle-center-box .middle-center-item {
  width: 30%;
  margin-right: 3%;
  margin-bottom: 1%;
}
.middle-center-box .middle-center-item .title {
  font-size: 28px;
  color: #51b5fd;
  margin-bottom: 10px;
}
.middle-center-box .middle-center-item .info {
  background: black;
  color: #fff;
  width: 100%;
  border-radius: 10px;
}
.middle-center-box .middle-center-item .info > div {
  display: flex;
  text-align: center;
  padding: 10px;
  font-size: 20px;
}
.middle-center-box .middle-center-item .info > div > div {
  width: 33%;
}
.middle-bottom-box {
  display: flex;
  align-items: center;
}
.middle-bottom-box .bottom-item {
  width: 33%;
  text-align: center;
  font-size: 28px;
  color: #fff;
}
.middle-bottom-box .bottom-item .title {
  margin-bottom: 20px;
}
/* echarts */
/* 汽废左侧饼图 */
.left-echarts-1,
.left-echarts-2,
.left-echarts-3 {
  width: 100%;
  /* height: 80%; */
  height: 26vh;
}
.right-echarts-1,
.right-echarts-2,
.right-echarts-3 {
  width: 100%;
  height: 26vh;
}

::v-deep .el-range-input {
  background: transparent !important;
}
::v-deep .el-input__inner {
  background: transparent !important;
  color: #fff !important;
}
::v-deep .el-date-editor .el-range-separator {
  color: #fff !important;
}
::v-deep .el-date-editor .el-range-input {
  color: #fff !important;
  width: 100px !important;
}
::v-deep .el-date-editor {
  width: 220px;
  padding: unset;
  box-sizing: border-box;
}
::v-deep .el-date-editor .el-range-separator {
  line-height: unset !important;
}
::v-deep .el-date-editor .el-range__icon {
  display: none !important;
}
.current {
  margin-top: 20px;
}
.current-left {
  display: flex;
  font-size: 26px;
  text-align: left;
}
.current-left .img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.current-right {
  font-size: 30px;
  text-align: right;
}
.current-right span:last-child {
  font-size: 20px;
}
.supplier {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
}

.supplier .supplier-supplieritme {
  width: 50%;
  /* text-align: center; */
  font-size: 18px;
  /* margin-top: 15px; */
  /* padding: 20px; */
  padding-top: 20px;
  box-sizing: border-box;
}
.supplier-name {
  margin-bottom: 5px;
}
.supplier-count {
  /* text-align: center; */
  /* padding-left: 20px; */
}
</style>
  